<template>
	<div>
        <div class="noticeWrap">
            <div class="newsTabWrap">
                <div @click="link2Route(7)" :class="{on:cate==7}">{{ $t('board_of_directors') }}</div>
                <div @click="link2Route(9)" :class="{on:cate==9}">{{ $t('board_of_supervisors') }}</div>
                <div @click="link2Route(10)" :class="{on:cate==10}">{{ $t('other_executives') }}</div>
            </div>
            <div class="listWrap">
                <co-item :NoticeItem="item" v-for="(item,index) in noticeList" :key="index" />
            </div>
        </div>
	</div>
</template>

<script>
	export default {
        props: ['NoticeItem'],
		data() {
			return {
                cate:this.$route.params.type,
                noticeList:[]
			}
		},
		computed: {
			coname:function(){
                return '董事会'
            }
		},
		async mounted() {
            let data = await this.$util.getNoticeList({cate:this.cate,lang:localStorage.getItem('language') || 'zh-cn'})
            this.noticeList = data.list;
		},
		methods: {
            link2Route(id){
				this.$router.push(`/co/${id}`);
			}
		}
	}
</script>
<style lang="scss" scoped>
.noticeWrap{
    .newsTabWrap {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 0.2rem;
        >div {
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.24rem;
            font-weight: 400;
            color: rgba($color: #161A1A, $alpha: 1.0);
            min-width: 1.48rem;
            padding: 0 0.1rem;
            height: 0.66rem;
            border-radius: 33px;
            text-align: center;
            &.on {
                background: #C8EDE9;
                font-weight: bold;
                color: #161A1A;
            }
        }
    }

    .listWrap{
        margin-top: 0.1rem;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/notice/coList.vue